import { render, staticRenderFns } from "./editable-input.vue?vue&type=template&id=672ba61a&scoped=true&"
import script from "./editable-input.vue?vue&type=script&lang=ts&"
export * from "./editable-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ba61a",
  null
  
)

export default component.exports